/**
 * @fileoverview Admin AI Usage Page
 *
 * Purpose: Platform-wide AI spend broken down per organisation for the
 * current month. Super-admin only — the underlying query enforces the role.
 * URL: /admin/ai-usage
 * Protection: Requires super_admin role.
 *
 * Dependencies:
 * - AdminAiUsageTable (src/components/agents/universal)
 * - Convex: lib.aiUsageQueries.getPlatformUsageBreakdown (via the table)
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@cvx/_generated/api";
import { AdminAiUsageTable } from "@/components/agents/universal";

export const Route = createFileRoute("/_app/_auth/admin/_layout/ai-usage")({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(
      convexQuery(api.users.queries.getCurrentUser, {}),
    );
    if (!user?.isOwner) {
      throw redirect({ to: "/admin/master-library" });
    }
  },
  component: AiUsagePage,
});

function AiUsagePage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-semibold">AI Usage</h1>
        <p className="text-sm text-muted-foreground">
          Platform-wide AI spend by organisation for the current month.
        </p>
      </div>

      <AdminAiUsageTable />
    </div>
  );
}
